import React from "react";
import { Outlet } from "react-router-dom";
import LeftNav from "../navigation/left-nav";
import RightNav from "../navigation/right-nav";
import TopNav from "../navigation/top-nav";
import EnterpriseAccountSetup from "../account-invitation/enterprise-account-setup-wizard";
import EnterpriseAccountSetupTopNav from "../account-invitation/enterprise-account-setup-wizard/navigation/top-nav";
import Backdrop from "components/common/backdrop/backdrop";

export function EnterpriseAccountSetupLayout() {
    return <>
        <EnterpriseAccountSetupTopNav/>
        <div className="main-scroll">
            <div className="main-wrapper">
                <EnterpriseAccountSetup />
            </div>
        </div>
    </>;
}

export function MainLayout() {
    return <>

        <TopNav/>
        <RightNav/>
        <div className="main-scroll">
            <div className="main-wrapper">
                <LeftNav />
                <div className="main-content">
                    <Backdrop />
                    <Outlet />
                </div>
            </div>
        </div>
    </>;
}
